import { createAction, handleActions } from 'redux-actions';
import { PATH_DELIMITER } from '../constant/Constant';

const BASE = 'blockdisplay';
const BLOCK_DISPLAY = BASE + PATH_DELIMITER + 'BLOCK_DISPLAY';
const UNBLOCK_DISPLAY = BASE + PATH_DELIMITER + 'UNBLOCK_DISPLAY';

export const block = createAction(BLOCK_DISPLAY);
export const unblock = createAction(UNBLOCK_DISPLAY);

const initialState = {
    open: false,
};

const module = handleActions(
    {
        [BLOCK_DISPLAY]: (state) => ({ ...state, open: true }),
        [UNBLOCK_DISPLAY]: (state) => ({ ...state, open: false }),
    },
    initialState,
);

export default module;
